(function() {
     var sessionSoundOn = false;
     try { sessionSoundOn = sessionStorage.getItem('fsSoundOn') === 'true'; } catch
  (e) {}

     document.addEventListener('mousedown', function(e) {
       var muteBtn = e.target.closest && e.target.closest('.fs-mute');
       if (!muteBtn) return;
       setTimeout(function() {
         sessionSoundOn = !muteBtn.classList.contains('fs-mute--muted');
         try { sessionStorage.setItem('fsSoundOn', String(sessionSoundOn)); } catch
  (e) {}
       }, 0);
     }, true);

     function attachObserver() {
       new MutationObserver(function(mutations) {
         if (!sessionSoundOn) return;
         for (var i = 0; i < mutations.length; i++) {
           var addedNodes = mutations[i].addedNodes;
           for (var j = 0; j < addedNodes.length; j++) {
             var node = addedNodes[j];
             if (node.nodeType !== 1) continue;
             var videos = (node.matches && node.matches('video.fs-embed'))
               ? [node]
               : (node.querySelectorAll ? node.querySelectorAll('video.fs-embed') :
 []);
             for (var k = 0; k < videos.length; k++) {
               (function(v) {
                 setTimeout(function() {
                   v.muted = false;
                   var btn = document.querySelector('.fs-mute');
                   if (btn) btn.classList.remove('fs-mute--muted');
                 }, 50);
               })(videos[k]);
             }
           }
         }
       }).observe(document.body, { childList: true, subtree: true });
     }

     if (document.body) attachObserver();
     else document.addEventListener('DOMContentLoaded', attachObserver);
   })();